import React from 'react'

export default (props) => {
    return (<div>
        Welcome to Production Manager
    </div>)
};




// WEBPACK FOOTER //
// ./src/ui/pages/IndexPage.js